import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import api from '../../services/api';


export const useProductStore = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {
      // If it's FormData, let axios/browser handle the Content-Type and boundary
      const config = body instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};

      const res = await api.post("/product/create", body, config);
      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['viewProduct'] });
      queryClient.invalidateQueries({ queryKey: ['viewSubscription'] });
    },
  });

};